export default __webpack_public_path__ + "static/media/profile3.ce6e0796.svg";